import React, {useContext} from 'react';
import classNames from 'classnames';
import {Link} from './Link.jsx';
import {TextColor, TextPosition} from './text-modifiers';
import {TrackingContext, TrackingContextOverride} from './TrackingContext.jsx';
import {CfEntry} from './CfPreviewContext.jsx';
import {XRay} from '@teaser/scripts/components/XRay.jsx';

/**
 * @typedef {TeaserLinkModel} PriceTagModel
 * @property {string|null} formattedPrice
 * @property {TextColor} textColor
 * @property {TextPosition} textPosition
 * @property {string} title
 * @property {string} contentType
 * @property {boolean} showTitle
 * @property {boolean} isWow
 * @property {boolean} isTopDeal
 * @property {string|null} formattedFormerPrice
 * @property {number|null} priceReduction
 * @property {string} entryId
 */

/**
 * @param {PriceTagModel} model
 * @returns {JSX.Element}
 */
export function PriceTag({model}) {
    const parentContext = useContext(TrackingContext);
    let landmarkConfig = {
        id: model.entryId,
        teaser_id: parentContext.id,
        cfEnvironment: parentContext.cfEnvironment,
        teaserPageEntryId: parentContext.teaserPageEntryId,
        page: parentContext.page,
    };
    return (
        <TrackingContextOverride value={landmarkConfig}>
            <CfEntry entryId={model.entryId} contentType={model.contentType}>
                <div
                    className={classNames(
                        'content-platform__price-tag',
                        TextColor[model.textColor],
                        TextPosition[model.textPosition],
                    )}
                >
                    <XRay fieldId="product" />
                    <div className="content-platform__price-tag__inner">
                        {model.isTopDeal ? (
                            <span className="content-platform__price-tag__top-deal">TOP DEAL</span>
                        ) : (
                            model.isWow && <span className="content-platform__price-tag__wow">WOW!</span>
                        )}
                        <p className={classNames('content-platform__price-tag__title', !model.showTitle && 'hidden')}>
                            {model.title}
                        </p>
                        <div
                            className={classNames(
                                'content-platform__price-tag__price',
                                model.formattedFormerPrice && '-sale-red',
                            )}
                        >
                            <div className="content-platform__price-tag__price__whole-number">
                                {model.formattedPrice}
                            </div>
                        </div>
                    </div>
                    {model.formattedFormerPrice && (
                        <div className="content-platform__price-tag__former-price">
                            <div className="content-platform__price-tag__former-price__whole-number -line-through">
                                {model.formattedFormerPrice}
                            </div>
                            <p className="content-platform__price-tag__former-price__reduction">
                                -{model.priceReduction}%
                            </p>
                        </div>
                    )}
                    <Link model={model} className="content-platform__price-tag__link" aria-label={model.title} />
                </div>
            </CfEntry>
        </TrackingContextOverride>
    );
}
